import { render, staticRenderFns } from "./create_core_waybill.vue?vue&type=template&id=fbf67d38&scoped=true&"
import script from "./create_core_waybill.vue?vue&type=script&lang=js&"
export * from "./create_core_waybill.vue?vue&type=script&lang=js&"
import style0 from "./create_core_waybill.vue?vue&type=style&index=0&id=fbf67d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf67d38",
  null
  
)

export default component.exports